module.exports = __webpack_public_path__ + "static/Icons_DownpAssist_inactive-8fe1db2e213d43c3b021644b9e5e75d2.png";